// Git コマンド学習用データ
// 形は既存のデータと互換（text, color は必須。mondai/usage/example なども可能な範囲で付与）

export const gitCommands = [
  {
    text: "init",
    color: "#F4511E",
    kunyomi: "ここから始める。歴史は今刻まれる。",
    mondai: "新しいリポジトリを作りたい。",
    example: [
      "$ git init"
    ],
    origin: "空の .git ディレクトリを作成し、バージョン管理を開始する。",
    usage: "既存ディレクトリを Git 管理下に置く最初の一歩。"
  },
  {
    text: "clone",
    color: "#6D4C41",
    kunyomi: "遠き地の歴史を手元へ。",
    mondai: "リモートのリポジトリをローカルに複製したい。",
    example: [
      "$ git clone https://github.com/owner/repo.git"
    ],
    origin: "既存リポジトリをコピーして作業開始。",
    usage: "SSH/HTTPS など認証方法に応じて URL を使い分ける。"
  },
  {
    text: "status",
    color: "#1E88E5",
    kunyomi: "今を把握せよ。変化はどこだ。",
    mondai: "変更状況を確認したい。",
    example: [
      "$ git status"
    ],
    origin: "作業ツリーとステージの状態を表示。",
    usage: "add/commit 前の確認は習慣にすると事故が減る。"
  },
  {
    text: "add",
    color: "#43A047",
    kunyomi: "選び、舞台に上げよ。",
    mondai: "変更したファイルをコミット対象にしたい。",
    example: [
      "$ git add src/app.js",
      "$ git add ."
    ],
    origin: "インデックス（ステージ）に変更を追加。",
    usage: "ファイル単位でこまめにステージすると、綺麗なコミットが作りやすい。"
  },
  {
    text: "commit",
    color: "#FB8C00",
    kunyomi: "刻め、ひと区切りの物語を。",
    mondai: "ステージした変更を履歴に記録したい。",
    example: [
      "$ git commit -m \"feat: add login form\""
    ],
    origin: "ステージのスナップショットを履歴に追加。",
    usage: "粒度を適切に、メッセージは要約+詳細でわかりやすく。"
  },
  {
    text: "log",
    color: "#8E24AA",
    kunyomi: "過去を辿れ。答えは記録にある。",
    mondai: "履歴の一覧を見たい。",
    example: [
      "$ git log --oneline --graph --decorate --all"
    ],
    origin: "コミット履歴を表示。",
    usage: "--oneline や --graph で俯瞰性が上がる。"
  },
  {
    text: "diff",
    color: "#3949AB",
    kunyomi: "差を見極めよ。",
    mondai: "直近の変更差分を見たい。",
    example: [
      "$ git diff",
      "$ git diff --staged"
    ],
    origin: "ワークツリー/ステージ/コミット間の差分を表示。",
    usage: "レビュー前のセルフチェックに。"
  },
  {
    text: "branch",
    color: "#00796B",
    kunyomi: "道を分けよ。",
    mondai: "新しいブランチを作って作業したい。",
    example: [
      "$ git branch feature/login",
      "$ git branch"
    ],
    origin: "参照の枝（ブランチ）を管理。",
    usage: "命名規約を揃え、役割を明確に。"
  },
  {
    text: "switch",
    color: "#5C6BC0",
    kunyomi: "舞台を変えよ。",
    mondai: "別のブランチに切り替えたい。",
    example: [
      "$ git switch feature/login"
    ],
    origin: "安全にブランチを切り替える新コマンド（旧: checkout）。",
    usage: "ファイル退避が必要なら stash を併用。"
  },
  {
    text: "checkout",
    color: "#42A5F5",
    kunyomi: "古参の切替役。まだ現役。",
    mondai: "タグやコミット時点に一時的に切り替えたい。",
    example: [
      "$ git checkout v1.2.3",
      "$ git checkout -b fix/hot"
    ],
    origin: "ブランチ切替/作成、パス単位復元等も担う多機能。",
    usage: "近年は switch/restore に役割分割。"
  },
  {
    text: "merge",
    color: "#C2185B",
    kunyomi: "枝を束ねよ。",
    mondai: "feature ブランチを main に統合したい。",
    example: [
      "$ git switch main",
      "$ git merge feature/login"
    ],
    origin: "二つの履歴をマージコミットで統合。",
    usage: "コンフリクト時は落ち着いて解決→add→commit。"
  },
  {
    text: "rebase",
    color: "#F06292",
    kunyomi: "歴史を書き換え、筋道を整えよ。",
    mondai: "直線的な履歴に整えたい。",
    example: [
      "$ git rebase main",
      "$ git rebase -i HEAD~3"
    ],
    origin: "ベースを付け替え履歴を並べ替える。",
    usage: "共有済み履歴の書き換えは厳禁。ローカルで。"
  },
  {
    text: "fetch",
    color: "#039BE5",
    kunyomi: "遠方の変化を取り寄せよ。",
    mondai: "リモートの更新をローカルに反映したい（マージはまだ）。",
    example: [
      "$ git fetch origin"
    ],
    origin: "リモートの参照更新を取得。",
    usage: "pull 前に様子を見るのに有用。"
  },
  {
    text: "pull",
    color: "#7CB342",
    kunyomi: "受け入れ、交わりを果たせ。",
    mondai: "リモートの変更を取り込みたい。",
    example: [
      "$ git pull --ff-only",
      "$ git pull --rebase"
    ],
    origin: "fetch + merge（または rebase）。",
    usage: "--ff-only で不要なマージコミットを防ぐ。"
  },
  {
    text: "push",
    color: "#EF5350",
    kunyomi: "押し上げよ。成果を共有せよ。",
    mondai: "ローカルのコミットをリモートへ送りたい。",
    example: [
      "$ git push origin main"
    ],
    origin: "ローカルの参照をリモートへ反映。",
    usage: "保護ブランチのルールやレビュー有無に留意。"
  },
  {
    text: "remote",
    color: "#8D6E63",
    kunyomi: "つながりを管理せよ。",
    mondai: "新しいリモートを追加したい。",
    example: [
      "$ git remote add origin git@github.com:owner/repo.git",
      "$ git remote -v"
    ],
    origin: "リモート（名前とURL）の設定を管理。",
    usage: "URL 更新は set-url。不要なら削除も。"
  },
  {
    text: "stash",
    color: "#009688",
    kunyomi: "一時にしまい、道を空けよ。",
    mondai: "作業中の変更を一旦避難してブランチを切り替えたい。",
    example: [
      "$ git stash push -m \"wip: refactor\"",
      "$ git stash pop"
    ],
    origin: "未コミット変更を一時退避する。",
    usage: "部分指定なら -p。pop で戻すと同時に削除。"
  },
  {
    text: "tag",
    color: "#FFA000",
    kunyomi: "名を与え、記念せよ。",
    mondai: "リリース版にバージョン名を付けたい。",
    example: [
      "$ git tag v1.2.3",
      "$ git push origin v1.2.3"
    ],
    origin: "コミットにわかりやすい目印を貼る。",
    usage: "注釈付き（-a）で署名やメモを残すと親切。"
  },
  {
    text: "reset",
    color: "#5E35B1",
    kunyomi: "戻れ。ただし代償を知れ。",
    mondai: "HEAD を戻したい（作業ツリーは保持したい）。",
    example: [
      "$ git reset --soft HEAD~1",
      "$ git reset --mixed HEAD~1",
      "$ git reset --hard HEAD~1"
    ],
    origin: "HEAD/インデックス/ワークツリーを指定モードで巻き戻す。",
    usage: "--hard は破壊的。取り返しがつかない場合がある。"
  },
  {
    text: "revert",
    color: "#7E57C2",
    kunyomi: "罪は罪で打ち消せ。",
    mondai: "共有されたコミットの内容を取り消したい。",
    example: [
      "$ git revert <commit>"
    ],
    origin: "対象コミットの逆差分を新しいコミットとして追加。",
    usage: "共有履歴を壊さずに取り消す正式な手段。"
  },
  {
    text: "restore",
    color: "#26A69A",
    kunyomi: "姿を戻せ。",
    mondai: "変更したファイルを直近のコミット状態に戻したい。",
    example: [
      "$ git restore path/to/file",
      "$ git restore --staged path/to/file"
    ],
    origin: "checkout から分離された復元担当。",
    usage: "--staged でステージから外す（インデックス操作）。"
  },
  {
    text: "cherry-pick",
    color: "#EC407A",
    kunyomi: "必要な果実だけを摘み取れ。",
    mondai: "別ブランチの特定コミットだけ取り込みたい。",
    example: [
      "$ git cherry-pick <commit>"
    ],
    origin: "一部のコミットだけを現在のブランチに適用。",
    usage: "コンフリクト解決後は続行（--continue）。"
  },
  {
    text: "reflog",
    color: "#558B2F",
    kunyomi: "足跡を追え。迷い子を救え。",
    mondai: "HEAD を誤って動かしたが、戻したい。",
    example: [
      "$ git reflog",
      "$ git reset --hard HEAD@{2}"
    ],
    origin: "参照の移動履歴（ローカル専用）を記録。",
    usage: "消えたブランチの復旧に役立つことがある。"
  },
  {
    text: "blame",
    color: "#9E9D24",
    kunyomi: "行の由来を問え。",
    mondai: "この行を誰がいつ書いたか知りたい。",
    example: [
      "$ git blame src/app.js -L 10,30"
    ],
    origin: "各行のコミット由来を注釈。",
    usage: "責任追及より、背景理解と改善の手がかりに。"
  },
  {
    text: "show",
    color: "#00897B",
    kunyomi: "差と実体を見せよ。",
    mondai: "特定コミットやタグの内容を表示したい。",
    example: [
      "$ git show <commit>",
      "$ git show v1.2.3"
    ],
    origin: "オブジェクト（コミット/タグ/ツリー等）の内容を表示。",
    usage: "差分とメタ情報をまとめて確認できる。"
  },
  {
    text: "describe",
    color: "#7B1FA2",
    kunyomi: "名乗れ、近き印で。",
    mondai: "コミットに最も近いタグで短い名前を知りたい。",
    example: [
      "$ git describe --tags"
    ],
    origin: "最近接タグと距離でバージョン風表記を返す。",
    usage: "CI でバージョン名を自動生成するとき便利。"
  },
  {
    text: "bisect",
    color: "#455A64",
    kunyomi: "真ん中を切り分けろ。",
    mondai: "バグを導入したコミットを特定したい。",
    example: [
      "$ git bisect start",
      "$ git bisect bad",
      "$ git bisect good <commit>"
    ],
    origin: "二分探索で原因コミットを特定。",
    usage: "自動テストと組み合わせると強力。"
  },
  {
    text: "clean",
    color: "#C62828",
    kunyomi: "不要は払え。",
    mondai: "無視ファイルを含む未追跡ファイルを消したい。",
    example: [
      "$ git clean -fdx"
    ],
    origin: "未追跡ファイル/ディレクトリを削除。",
    usage: "破壊的。実行前に -n でドライラン確認。"
  },
  {
    text: "submodule",
    color: "#3949AB",
    kunyomi: "他者の力を借りよ。",
    mondai: "別リポジトリを子として組み込みたい。",
    example: [
      "$ git submodule add https://github.com/owner/lib.git libs/lib"
    ],
    origin: "外部リポジトリを特定コミット固定で参照。",
    usage: "更新・同期の手順をチームで共有しておく。"
  },
  {
    text: "worktree",
    color: "#00695C",
    kunyomi: "もう一つの作業場を作れ。",
    mondai: "別ブランチを別フォルダで同時に作業したい。",
    example: [
      "$ git worktree add ../repo-fix fix/urgent"
    ],
    origin: "同一リポジトリに複数の作業ツリーを持つ。",
    usage: "レビュー対応や並行作業が楽になる。"
  },
  {
    text: "config",
    color: "#00796B",
    kunyomi: "規矩を定めよ。",
    mondai: "ユーザ名やメール、エイリアスを設定したい。",
    example: [
      "$ git config --global user.name \"Your Name\"",
      "$ git config --global user.email you@example.com"
    ],
    origin: "Git の設定値を参照/変更。",
    usage: "--global と --local のスコープを理解して使い分ける。"
  },
  {
    text: "rm",
    color: "#D32F2F",
    kunyomi: "追跡ごと断て。",
    mondai: "Git の管理対象からファイルを削除したい。",
    example: [
      "$ git rm path/to/file",
      "$ git rm --cached path/to/file  # 追跡だけ外してファイルは残す"
    ],
    origin: "ファイル削除をステージし、履歴に反映する。",
    usage: "ワークツリーからも消える。残したい場合は --cached。\n削除後は commit して履歴に記録する。"
  },
  {
    text: "mv",
    color: "#1976D2",
    kunyomi: "名を変え、道を通せ。",
    mondai: "ファイル名変更（移動）を Git として正しく記録したい。",
    example: [
      "$ git mv old_name.txt new_name.txt",
      "$ git mv src/old.js src/new.js"
    ],
    origin: "移動/リネームをまとめて行い、その変更をステージする。",
    usage: "実体はリネーム＋add＋rm のショートカット。\n後で diff するとリネームとして検出されやすい。"
  },
  {
    text: "grep",
    color: "#388E3C",
    kunyomi: "歴史と今を、文字で探れ。",
    mondai: "リポジトリ内から文字列を高速に検索したい。",
    example: [
      "$ git grep \"TODO\"",
      "$ git grep -n \"useEffect\" -- src"
    ],
    origin: "Git 管理下のファイルを対象に高速検索する。",
    usage: "OSのgrepより、Git管理対象に絞れるのが利点。\nオプションで行番号表示（-n）や対象パス指定も可能。"
  }
];
